import { OrganisationApplicationFeature } from "@cnx/common";
import api from "services/api";

class ApplicationFeatureService {
  static async getAllFeatures() {
    const { data } = await api.get<OrganisationApplicationFeature[]>(
      "/organisation-application-features"
    );
    return data;
  }
}
export default ApplicationFeatureService;
